import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlag as faFlagSolid } from "@fortawesome/free-solid-svg-icons";
import { faFlag as faFlagRegular } from "@fortawesome/free-regular-svg-icons";
import "../../components/PatientDashboard/Table.css";
import "./assessmentPage.css";
import {
  getUserAssessment,
  allTemplatesAPI,
  addAssessmentsAPI,
} from "../../api/api";
import AllUserAssessments from "./AllUserAssessments";
import { Input, Checkbox, Button, Modal, DatePicker } from "antd";
import "./assessmentPage.css";
import LoadingSpiner from "../Common/LoadingSpiner";
import { PlusOutlined } from "@ant-design/icons";

export default function UserAssessmentModal({
  isVisible,
  setIsVisible,
  selectedUser,
}) {
  // states
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(true);
  const [testLoading, setTestLoading] = useState(true);
  const [assessmentData, setAssessmentData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedTests, setSelectedTests] = useState([]);
  const [modalVisible, setmodalVisible] = useState(false);
  const [data, setData] = useState([]); // Initial empty array
  const [displayedData, setDisplayedData] = useState([]); // Also initialized to empty array
  const [selectedDate, setSelectedDate] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [currentTest, setCurrentTest] = useState(null);
  const [record, setRecord] = useState(null);
  const [addingTest, addTest] = useState(null);
  const [recurringAssessments, setRecurringAssessments] = useState([]);
  const [upcomingAssessments, setUpcomingAssessments] = useState([]);
  const [completedAssessments, setCompletedAssessments] = useState([]);
  const [recurringTemplateIds, setRecurringTemplateIds] = useState([]);

  useEffect(() => {
    if (token) {
      fetchAssessmentData();
    }
  }, [token, addingTest]);

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [token]);

  const fetchAssessmentData = async () => {
    setTestLoading(true);
    try {
      const res = await getUserAssessment(selectedUser._id);

      // The response object has 'upcoming', 'recurring', and 'past' properties
      if (res) {
        setUpcomingAssessments(res.upcoming || []);
        setCompletedAssessments(res.past || []);
        setRecurringAssessments(res.recurring || []);
        const templateIds = res.recurring.map(
          (assessment) => assessment.templateId._id
        );
        setRecurringTemplateIds(templateIds);
      } else {
        throw new Error("Invalid response data");
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
    setTestLoading(false);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await allTemplatesAPI();
      if (res && Array.isArray(res)) {
        setData(res);
        setDisplayedData(res);
      } else {
        throw new Error("Received data is not an array");
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setData([]);
      setDisplayedData([]);
    }
    setLoading(false);
  };

  const handleModal = () => {
    setIsVisible(false);
  };

  const onSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    if (data != undefined) {
      // Additional safeguard
      const filteredData = data.filter(
        (entry) =>
          entry.title && entry.title.toLowerCase().includes(value.toLowerCase())
      );

      setDisplayedData(filteredData);
    }
  };

  const onTestSelectChange = (e, key) => {
    const newSelectedTests = e.target.checked
      ? [...selectedTests, key]
      : selectedTests.filter((itemKey) => itemKey !== key);
    setSelectedTests(newSelectedTests);
  };

  const handleOk = async () => {
    if (selectedDate && currentTest && record) {
      const date = new Date();
      try {
        await addAssessmentsAPI({
          patientId: record,
          status: "Assigned",
          templateId: currentTest,
          assignedDate: selectedDate,
          dueDate: dueDate,
        });
      } catch (error) {
        console.error("Failed to assign test:", error);
      }
    }
    addTest(record);
    setmodalVisible(false);
  };

  const handlePlusButtonClick = (id) => {
    setRecord(selectedUser._id);
    setCurrentTest(id);
    setmodalVisible(true);
  };

  const renderModal = () => {
    return (
      <Modal
        title="Select a due date"
        open={modalVisible}
        onOk={handleOk}
        onCancel={() => setmodalVisible(false)}
        okButtonProps={{ className: "modal-ok-button" }}
        okText="Add Assessment"
      >
        <div style={{ display: "flex" }}>
          <DatePicker
            onChange={setSelectedDate}
            style={{ marginRight: "20px", width: "170px" }}
            placeholder="Assignment Date"
          />
          <DatePicker onChange={setDueDate} placeholder="Due Date" />
        </div>
      </Modal>
    );
  };

  const assessments = [
    {
      title: "PHQ-9 - Patient Health Questionnaire",
      assignedDate: "6/07/24",
      completedDate: null,
      score: null,
    },
    {
      title: "Assessment #10 - Adherence",
      assignedDate: "6/07/24",
      completedDate: null,
      score: null,
    },
    {
      title: "Assessment #12 - Notifications",
      assignedDate: "6/07/24",
      completedDate: null,
      score: null,
    },
    {
      title: "PHQ-9 - Patient Health Questionnaire",
      assignedDate: "6/07/24",
      completedDate: "8/24/24",
      score: "8.9",
    },
    {
      title: "Assessment #5 - Drinking Habits",
      assignedDate: "6/07/24",
      completedDate: "8/24/24",
      score: "6.0",
    },
  ];

  return (
    <Modal
      open={isVisible}
      width={1000}
      onCancel={() => handleModal()}
      cancelButtonProps={{ style: { display: "none" } }}
      footer={null}
    >
      <hr />
      <div style={{ display: "flex", flexDirection: "row", marginTop: "15px" }}>
        {/* assessments */}
        <div style={{ width: "50%" }}>
          <div style={{ display: "flex" }}>
            <h1 style={{ fontSize: "30px", paddingRight: "10px" }}>
              Assessments
            </h1>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon icon={faFlagRegular} className="flagStyles" />
              <p>: incomplete</p>
              <FontAwesomeIcon icon={faFlagSolid} className="flagStyles" />
              <p>: complete</p>
            </div>
          </div>
          <div>
            {!testLoading ? (
              <div>
                {/* Recurring Assessments */}
                <h2 className="assessment-header">Recurring</h2>
                {recurringAssessments.map((assessment, index) => (
                  <AssessmentCard
                    key={index}
                    title={assessment.templateId.title}
                    assignedDate={assessment.assignedDate}
                    completedDate={assessment.CompletionDate}
                    score={assessment.score}
                  />
                ))}

                {/* Upcoming Assessments */}
                <h2 className="assessment-header">Upcoming</h2>
                {upcomingAssessments.map((assessment, index) => (
                  <AssessmentCard
                    key={index}
                    title={assessment.templateId.title}
                    assignedDate={assessment.assignedDate}
                  />
                ))}

                {/* Completed Assessments */}
                <h2 className="assessment-header">Completed</h2>
                {completedAssessments.map((assessment, index) => (
                  <AssessmentCard
                    key={index}
                    title={assessment.templateId.title}
                    assignedDate={assessment.assignedDate}
                    completedDate={assessment.CompletionDate}
                    score={assessment.score}
                  />
                ))}
              </div>
            ) : (
              <LoadingSpiner />
            )}
          </div>
        </div>
        {/* assign to user */}
        <div style={{ width: "50%" }}>
          <div>
            <h1 style={{ fontSize: "30px" }}>
              Assign to {selectedUser.user.name}
            </h1>
            <div>
              <div>
                <Input
                  placeholder="Search by name..."
                  value={searchText}
                  onChange={onSearch}
                  style={{
                    marginTop: "20px",
                    width: "90%",
                    marginLeft: "25px",
                  }}
                />
              </div>
            </div>
            <div>
              {displayedData && displayedData.length > 0 ? (
                displayedData.map((item) => {
                  const isRecurring = recurringTemplateIds.includes(item._id);
                  return (
                    <div key={item._id}>
                      <div className="card">
                        <div className="flex-row">
                          <div
                            style={{ alignSelf: "center", marginLeft: "5px" }}
                          >
                            <Checkbox
                              onChange={(e) => onTestSelectChange(e, item._id)}
                              checked={selectedTests.includes(item._id)}
                              className="customCheckbox"
                              style={{ borderRadius: "0px" }}
                            />
                          </div>
                          <div className="card-header">
                            <div
                              className="flex-row"
                              style={{
                                width: "100%",
                                justifyContent: "space-between",
                                alignContent: "center",
                              }}
                            >
                              <div
                                className="flex-col"
                                style={{ justifyContent: "space-between" }}
                              >
                                <h3 style={{ fontSize: "15px" }}>
                                  {item.title}
                                </h3>
                                <p style={{ paddingRight: "10px" }}>
                                  View Form
                                </p>
                              </div>
                              <Button
                                type="primary"
                                shape="circle"
                                icon={<PlusOutlined />}
                                style={{
                                  backgroundColor: isRecurring
                                    ? "gray"
                                    : "#6434FF", // Disable button style if recurring
                                  alignSelf: "center",
                                  cursor: isRecurring
                                    ? "not-allowed"
                                    : "pointer", // Change cursor to indicate it's not clickable
                                }}
                                disabled={isRecurring} // Disable button if the item is recurring
                                onClick={() => handlePlusButtonClick(item._id)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>
                  {loading ? "Loading assessments..." : "No assessments found."}
                </p>
              )}
            </div>
            {renderModal()}
          </div>
        </div>
      </div>
    </Modal>
  );
}

const AssessmentCard = ({ title, assignedDate, completedDate, score }) => {
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="card">
      <div className="flex-row">
        <div>
          <FontAwesomeIcon
            icon={completedDate ? faFlagSolid : faFlagRegular}
            className="flagStyles"
          />
        </div>
        <div className="card-header">
          <h3>{title}</h3>
          <div className="flex-row" style={{ justifyContent: "space-between" }}>
            <p style={{ paddingRight: "10px" }}>
              Assigned: {formatDate(assignedDate)}
            </p>
            {completedDate && <p>Completed: {formatDate(completedDate)}</p>}
          </div>
          {completedDate && (
            <div className="flex-row card-footer">
              <p className="score">Score: {score}</p>
              <button className="bg-[#6434FFB8] w-[94px] h-[32px] text-white rounded-full text-[12px]">
                View Results
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
